/* ── Prescription Flyout — Web Component ── */

class PrescriptionFlyout extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    var self = this;
    var body = document.body;

    // Reparent self to body so ancestor stacking contexts (e.g. .product-content
    // gets a transform at >=2200px viewport) can't paint the flyout under the overlay
    if (this.parentNode !== body) {
      body.appendChild(this);
    }

    // Inject overlay div (appended to body so it covers the full viewport)
    var overlay = document.createElement('div');
    overlay.className = 'prescription-overlay';
    body.appendChild(overlay);
    self._overlay = overlay;

    // Cache key elements scoped to this component
    self._infoDialog = self.querySelector('#prescriptionInfoDialog');

    // Reparent dialog to body so it isn't trapped by flyout's overflow
    body.appendChild(self._infoDialog);

    // --- Open / Close ---
    self._open = function () {
      body.classList.add('open-prescription-aside');
      body.style.overflow = 'hidden';
      self._showStep('stepLensSelection');
    };

    self._close = function () {
      body.classList.remove('open-prescription-aside');
      body.style.overflow = '';
      // Reset to step 1 after close
      self._showStep('stepLensSelection');
    };

    // Intercept ALL Add to Bag buttons on the page (outside the component)
    var addToCartBtns = document.querySelectorAll('.single_add_to_cart_button');
    addToCartBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self._open();
      });
    });

    // Close button
    self.querySelector('#closePrescription').addEventListener('click', function (e) {
      e.preventDefault();
      self._close();
    });

    // --- Info Dialog ---
    self.addEventListener('click', function (e) {
      var icon = e.target.closest('.prescription-info-icon');
      if (!icon) return;
      self._infoDialog.style.display = 'flex';
    });

    self._infoDialog.querySelector('#closeInfoDialog').addEventListener('click', function () {
      self._infoDialog.style.display = 'none';
    });

    self._infoDialog.querySelector('.prescription-info-dialog__overlay').addEventListener('click', function () {
      self._infoDialog.style.display = 'none';
    });

    // Back button
    self.querySelector('#backPrescription').addEventListener('click', function (e) {
      e.preventDefault();
      var current = self.querySelector('.prescription-step[style*="block"]');
      if (!current) return;
      if (current.id === 'stepReview') {
        var selectedLens = self.querySelector('input[name="lens_type"]:checked');
        if (selectedLens && selectedLens.value === 'non-prescription') {
          self._showStep('stepLensSelection');
        } else {
          self._showStep('stepPrescriptionDetails');
        }
      } else if (current.id === 'stepPrescriptionDetails') {
        self._showStep('stepPrescriptionChoice');
      } else if (current.id === 'stepPrescriptionChoice') {
        self._showStep('stepLensSelection');
      }
    });

    // Overlay click to close
    overlay.addEventListener('click', self._close);

    // Escape key to close
    self._keydownHandler = function (e) {
      if (e.key === 'Escape' && body.classList.contains('open-prescription-aside')) {
        self._close();
      }
    };
    document.addEventListener('keydown', self._keydownHandler);

    // iOS Safari: when a field is focused the virtual keyboard covers the bottom
    // of the fixed flyout, hiding the CONTINUE button. Wait for the keyboard to
    // open, then scroll the button into view.
    self.addEventListener('focusin', function () {
      var active = self.querySelector('.prescription-step[style*="block"]');
      if (!active) return;
      var btn = active.querySelector('.prescription-btn');
      if (!btn) return;
      setTimeout(function () {
        btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }, 300);
    });

    // --- Same-for-Both-Eyes Toggle ---
    var sameForBothCheckbox = self.querySelector('#sameForBothEyes');
    var leftEyeSection = self.querySelector('#leftEyeSection');

    sameForBothCheckbox.addEventListener('change', function () {
      if (this.checked) {
        leftEyeSection.style.display = 'none';
      } else {
        leftEyeSection.style.display = 'contents';
      }
    });

    // --- Dual PD Toggle ---
    var dualPDCheckbox = self.querySelector('#hasDualPD');
    var pdSingleField = self.querySelector('#pdSingleField');
    var pdRightField = self.querySelector('#pdRightField');
    var pdLeftField = self.querySelector('#pdLeftField');

    dualPDCheckbox.addEventListener('change', function () {
      if (this.checked) {
        pdSingleField.style.display = 'none';
        pdRightField.style.display = '';
        pdLeftField.style.display = '';
      } else {
        pdSingleField.style.display = '';
        pdRightField.style.display = 'none';
        pdLeftField.style.display = 'none';
      }
    });

    // --- Next: Lens Selection → Prescription Choice (or skip to review) ---
    self.querySelector('#nextToPrescription').addEventListener('click', function () {
      var selectedLens = self.querySelector('input[name="lens_type"]:checked');
      if (!selectedLens) return;

      if (selectedLens.value === 'non-prescription') {
        self._populateReview();
        self._showStep('stepReview');
        return;
      }
      self._showStep('stepPrescriptionChoice');
    });

    // --- Next: Prescription Choice → Prescription Details or Review ---
    self.querySelector('#rxChoiceContinue').addEventListener('click', function () {
      var choice = self.querySelector('input[name="rx_choice"]:checked');
      if (!choice) return;

      if (choice.value === 'manual') {
        self._showStep('stepPrescriptionDetails');
      } else {
        self._populateReview();
        self._showStep('stepReview');
      }
    });

    // --- Continue: Prescription Details → Review ---
    self.querySelector('#goToReview').addEventListener('click', function () {
      var odSph = self.querySelector('#od_sph').value;
      if (!odSph) {
        alert('Please select SPH for your right eye.');
        return;
      }

      // --- CYL/AXIS plausibility: CYL and AXIS come as a pair ---
      // OS mirrors OD when "same for both eyes" is checked, so only validate
      // the left-eye selects independently when the eyes are entered separately.
      var eyePairs = [{ label: 'right', cyl: '#od_cyl', axis: '#od_axis' }];
      if (!self.querySelector('#sameForBothEyes').checked) {
        eyePairs.push({ label: 'left', cyl: '#os_cyl', axis: '#os_axis' });
      }
      for (var i = 0; i < eyePairs.length; i++) {
        var pair = eyePairs[i];
        var cylVal = self.querySelector(pair.cyl).value;
        var axisVal = self.querySelector(pair.axis).value;
        if (cylVal && !axisVal) {
          alert('Please select AXIS for your ' + pair.label + ' eye. CYL and AXIS must be entered together.');
          return;
        }
        if (!cylVal && axisVal) {
          alert('Please select CYL for your ' + pair.label + ' eye. CYL and AXIS must be entered together.');
          return;
        }
      }

      // --- PD is required when the prescription is entered manually ---
      var rxChoice = self.querySelector('input[name="rx_choice"]:checked');
      if (rxChoice && rxChoice.value === 'manual') {
        var pdMissing;
        if (self.querySelector('#hasDualPD').checked) {
          pdMissing = !self.querySelector('#pd_right').value || !self.querySelector('#pd_left').value;
        } else {
          pdMissing = !self.querySelector('#pd_single').value;
        }
        if (pdMissing) {
          alert('Please select your PD (pupillary distance).');
          return;
        }
      }

      self._populateReview();
      self._showStep('stepReview');
    });

    // --- Confirm checkbox: enable/disable submit ---
    self.querySelector('#reviewConfirm').addEventListener('change', function () {
      self.querySelector('#submitPrescription').disabled = !this.checked;
    });

    // --- Submit to Cart ---
    self.querySelector('#submitPrescription').addEventListener('click', function () {
      var selectedLens = self.querySelector('input[name="lens_type"]:checked');
      var lensType = selectedLens ? selectedLens.value : '';
      self._submitWithLensType(lensType);
    });
  }

  // --- Step Navigation ---
  _showStep(stepId) {
    var self = this;
    var steps = self.querySelectorAll('.prescription-step');
    steps.forEach(function (step) {
      step.style.display = 'none';
    });
    var target = self.querySelector('#' + stepId);
    if (target) target.style.display = 'block';

    // Update progress bar
    var pct = '25%';
    if (stepId === 'stepPrescriptionChoice') pct = '50%';
    else if (stepId === 'stepPrescriptionDetails') pct = '75%';
    else if (stepId === 'stepReview') pct = '100%';
    var fill = self.querySelector('#progressFill');
    if (fill) fill.style.width = pct;

    // Toggle back button disabled state
    var backBtn = self.querySelector('#backPrescription');
    if (backBtn) {
      backBtn.classList.toggle('is-disabled', stepId === 'stepLensSelection');
    }
  }

  // --- Reset all form fields to their default state (run after a successful add) ---
  _resetForm() {
    var self = this;

    // Default lens selection is non-prescription
    var nonRx = self.querySelector('input[name="lens_type"][value="non-prescription"]');
    if (nonRx) nonRx.checked = true;

    self.querySelectorAll('input[name="rx_choice"]').forEach(function (r) {
      r.checked = false;
    });

    // Reset all prescription selects to their placeholder
    self.querySelectorAll('select').forEach(function (s) {
      s.selectedIndex = 0;
    });

    // Default state: same-for-both-eyes off, left eye section visible
    var sameForBoth = self.querySelector('#sameForBothEyes');
    if (sameForBoth) sameForBoth.checked = false;
    var leftEye = self.querySelector('#leftEyeSection');
    if (leftEye) leftEye.style.display = '';

    // Default state: dual PD off, single PD field shown
    var dualPD = self.querySelector('#hasDualPD');
    if (dualPD) dualPD.checked = false;
    var pdSingle = self.querySelector('#pdSingleField');
    var pdRight = self.querySelector('#pdRightField');
    var pdLeft = self.querySelector('#pdLeftField');
    if (pdSingle) pdSingle.style.display = '';
    if (pdRight) pdRight.style.display = 'none';
    if (pdLeft) pdLeft.style.display = 'none';

    // Require re-confirmation on the next submission
    var reviewConfirm = self.querySelector('#reviewConfirm');
    if (reviewConfirm) reviewConfirm.checked = false;
    var submit = self.querySelector('#submitPrescription');
    if (submit) submit.disabled = true;

    self._showStep('stepLensSelection');
  }

  // --- Helper: get selected lens label ---
  _getSelectedLensLabel() {
    var self = this;
    var el = self.querySelector('input[name="lens_type"]:checked');
    if (!el) return '';
    var label = el.closest('.lens-option');
    return label ? label.querySelector('.lens-option__label').textContent.trim() : el.value;
  }

  // --- Populate review step ---
  _populateReview() {
    var self = this;
    var lensLabel = self._getSelectedLensLabel();
    var rxTables = self.querySelector('#reviewRxTables');
    var rxChoice = self.querySelector('input[name="rx_choice"]:checked');

    self.querySelector('#reviewLensType').textContent = lensLabel;

    // Get price from selected lens option
    var selectedLens = self.querySelector('input[name="lens_type"]:checked');
    var lensPrice = selectedLens ? selectedLens.closest('.lens-option').querySelector('.lens-option__price').textContent : '';
    self.querySelector('#reviewLensPrice').textContent = lensPrice;

    var isNonRx = selectedLens && selectedLens.value === 'non-prescription';

    // Set prescription value text
    var rxValueEl = self.querySelector('#reviewRxValue');
    if (isNonRx) {
      rxValueEl.textContent = 'Non-Prescription';
      rxTables.style.display = 'none';
    } else {
      if (rxChoice && rxChoice.value === 'send-later') {
        rxValueEl.textContent = 'Send it later';
        rxTables.style.display = 'none';
      } else {
        rxValueEl.textContent = 'Enter it manually';
        rxTables.style.display = '';

        // Populate OD values
        function formatRx(val) {
          if (!val && val !== '0') return '-';
          var num = parseFloat(val);
          if (isNaN(num)) return '-';
          var sign = num >= 0 ? '+' : '';
          return sign + num.toFixed(2);
        }

        var odSph = formatRx(self.querySelector('#od_sph').value);
        var odCyl = formatRx(self.querySelector('#od_cyl').value);
        var odAxis = self.querySelector('#od_axis').value || 'NONE';

        self.querySelector('#reviewOdSph').textContent = odSph;
        self.querySelector('#reviewOdCyl').textContent = odCyl;
        self.querySelector('#reviewOdAxis').textContent = odAxis;

        // Populate OS values — mirror OD if sameForBoth is checked
        var sameForBoth = self.querySelector('#sameForBothEyes').checked;
        if (sameForBoth) {
          self.querySelector('#reviewOsSph').textContent = odSph;
          self.querySelector('#reviewOsCyl').textContent = odCyl;
          self.querySelector('#reviewOsAxis').textContent = odAxis;
        } else {
          self.querySelector('#reviewOsSph').textContent = formatRx(self.querySelector('#os_sph').value);
          self.querySelector('#reviewOsCyl').textContent = formatRx(self.querySelector('#os_cyl').value);
          self.querySelector('#reviewOsAxis').textContent = self.querySelector('#os_axis').value || 'NONE';
        }

        // Populate PD
        var pdBody = self.querySelector('#reviewPdBody');
        var hasDualPD = self.querySelector('#hasDualPD').checked;
        if (hasDualPD) {
          var pdRight = self.querySelector('#pd_right').value;
          var pdLeft = self.querySelector('#pd_left').value;
          pdBody.innerHTML =
            '<tr><td>PD Right</td><td>' + (pdRight ? pdRight + ' mm' : '-') + '</td></tr>' +
            '<tr><td>PD Left</td><td>' + (pdLeft ? pdLeft + ' mm' : '-') + '</td></tr>';
        } else {
          var pdSingle = self.querySelector('#pd_single').value;
          pdBody.innerHTML = '<tr><td>PD</td><td>' + (pdSingle ? pdSingle + ' mm' : '-') + '</td></tr>';
        }
      }
    }

    // Reset confirm checkbox
    var reviewConfirmLabel = self.querySelector('#reviewConfirm').parentElement;
    var rxValueInline = self.querySelector('.review-rx-value');
    var isSendLater = rxChoice && rxChoice.value === 'send-later';
    reviewConfirmLabel.style.display = isSendLater ? 'none' : '';
    rxValueInline.style.marginBottom = isSendLater ? '190px' : '16px';
    self.querySelector('#reviewConfirm').checked = false;
    self.querySelector('#submitPrescription').disabled = isSendLater ? false : true;
  }

  // --- Add to Cart via AJAX ---
  _submitWithLensType(lensType) {
    var self = this;
    var body = document.body;

    // Frame variant: read the product form's synced hidden input
    var frameVariantInput = document.querySelector('input[name="id"]');
    var frameVariantId = frameVariantInput ? parseInt(frameVariantInput.value) : null;

    // Build line item properties
    var properties = {
      lens_type: lensType,
    };

    if (lensType === 'non-prescription') {
      properties['prescription'] = 'Non-Prescription';
    } else {
      var rxChoice = self.querySelector('input[name="rx_choice"]:checked');
      var isSendLater = rxChoice && rxChoice.value === 'send-later';

      if (isSendLater) {
        properties['prescription'] = 'Send it later';
      } else {
        var sameForBoth = self.querySelector('#sameForBothEyes').checked;

        // OD (Right Eye)
        var odSph = self.querySelector('#od_sph').value;
        var odCyl = self.querySelector('#od_cyl').value;
        var odAxis = self.querySelector('#od_axis').value;

        if (odSph) properties['OD SPH'] = odSph;
        if (odCyl) properties['OD CYL'] = odCyl;
        if (odAxis) properties['OD AXIS'] = odAxis;

        if (sameForBoth) {
          if (odSph) properties['OS SPH'] = odSph;
          if (odCyl) properties['OS CYL'] = odCyl;
          if (odAxis) properties['OS AXIS'] = odAxis;
        } else {
          var osSph = self.querySelector('#os_sph').value;
          var osCyl = self.querySelector('#os_cyl').value;
          var osAxis = self.querySelector('#os_axis').value;

          if (osSph) properties['OS SPH'] = osSph;
          if (osCyl) properties['OS CYL'] = osCyl;
          if (osAxis) properties['OS AXIS'] = osAxis;
        }

        // PD
        if (self.querySelector('#hasDualPD').checked) {
          var pdRight = self.querySelector('#pd_right').value;
          var pdLeft = self.querySelector('#pd_left').value;
          if (pdRight) properties['Right PD'] = pdRight;
          if (pdLeft) properties['Left PD'] = pdLeft;
        } else {
          var pdSingle = self.querySelector('#pd_single').value;
          if (pdSingle) properties['PD'] = pdSingle;
        }
      }
    }

    // Get selected lens variant ID
    var selectedLensRadio = self.querySelector('input[name="lens_type"]:checked');
    var lensVariantId = selectedLensRadio ? selectedLensRadio.getAttribute('data-variant-id') : null;

    // Generate bundle ID to link frame + lens
    var bundleId = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

    // Build lens-specific properties if a lens variant is selected
    var lensProps = null;
    if (lensVariantId) {
      lensProps = { lens_type: lensType, bundle_id: bundleId, lens_addon: 'true' };
    }

    // Add frame FIRST as a single item, then lens AFTER — sequential calls
    // ensure frame always appears above lens in the cart.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: frameVariantId, quantity: 1, properties: Object.assign({}, properties, { bundle_id: bundleId }) }],
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        // Frame added — now add the lens as a second call
        if (!lensProps) return Promise.resolve();
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(lensVariantId), quantity: 1, properties: lensProps }],
          }),
        }).then(function (r) {
          return r.json();
        });
      })
      .then(function () {
        self._close();
        self._resetForm();

        // Refresh cart flyout content (matches theme's g-addtocart.js pattern)
        fetch('/cart?view=json')
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var cartFlyout = document.querySelector('.cart-flyout');
            if (cartFlyout) cartFlyout.innerHTML = html;
          });

        // Update cart count badge
        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var badge = document.querySelector('.la-cart-count');
            if (badge) badge.innerHTML = cart.item_count;
          });

        body.classList.add('open-cart-aside');
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        alert('Something went wrong adding to your bag. Please try again.');
      });
  }
}

/* ── Register the custom element ── */
customElements.define('prescription-flyout', PrescriptionFlyout);

